import Button from 'components/form/Button';
import BackButton from 'components/layouts/BackButton';
import Transaction from 'pages/dashboard/Transaction';
import { getTransactions } from 'api/transaction';
import { toast } from 'react-toastify';

import React, { useEffect, useState } from 'react';
import Loader from 'components/layouts/Loader';

const Transactions = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchTransactions = async () => {
    setLoading(true);
    try {
      const res = await getTransactions();
      if (res?.data) {
        const data = res.data.map((item: any, index: number) => {
          return {
            sn: index + 1,
            ...item,
          };
        });
        setData(data);
      }
    } catch (error: any) {
      const { errors } = error.response.data;

      errors.map((err: { error: string }) => {
        if (err?.error) {
          return toast.error(err.error);
        } else {
          return toast.error('Something went wrong');
        }
      });
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchTransactions();
  }, []);
  return (
    <section className="py-5">
      <BackButton text="transactions" />
      <br />
      <Button className="my-5">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="h-6 w-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75"
          />
        </svg>
      </Button>
      {loading ? (
        <Loader />
      ) : (
        <Transaction data={data} hidePagination={false} size={8} />
      )}
    </section>
  );
};

export default Transactions;
